/**
 * Feature flag helper for Relationship Graph
 * 
 * Centralizes feature flag access to enable deterministic testing.
 * Tests can mock this function instead of dealing with env variable timing issues.
 */

/**
 * Check if Relationship Graph feature is enabled
 * @returns true if VITE_RELATIONSHIP_GRAPH_ENABLED is 'true'
 */
export function isRelationshipGraphEnabled(): boolean {
  const enabled = import.meta.env.VITE_RELATIONSHIP_GRAPH_ENABLED === 'true';
  if (import.meta.env.DEV) {
    console.debug(
      '[relationship-graph] enabled =',
      enabled,
      'env value =',
      import.meta.env.VITE_RELATIONSHIP_GRAPH_ENABLED
    );
  }
  return enabled;
}

